/* Market’s jire — animaciones al hacer scroll y pestañas de productos */
(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.clx-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initTabs(root) {
    (root || document).querySelectorAll('[data-clx-tabs]').forEach(function (wrap) {
      if (wrap.dataset.clxReady) return;
      wrap.dataset.clxReady = '1';
      var tabs = wrap.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.tabIndex = on ? 0 : -1;
            var panel = document.getElementById(t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
        });
      });
    });
  }

  function initDelivery(root) {
    (root || document).querySelectorAll('[data-clx-delivery]').forEach(function (el) {
      var min = parseInt(el.dataset.min || '2', 10), max = parseInt(el.dataset.max || '5', 10);
      var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
      function add(n) {
        var d = new Date();
        while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
        return d.getDate() + ' de ' + meses[d.getMonth()];
      }
      el.textContent = 'Entre el ' + add(min) + ' y el ' + add(max);
    });
  }

  function init(root) { initReveal(root); initTabs(root); initDelivery(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
